module.exports = __webpack_public_path__ + "img/google2.6b68b629.svg";